export const DESIGNER_MODULE_NAME = 'designer';
